<template>
  <div class="container" ref="scrollContainer">
    <div
      class="status-list"  
    >
      <div class="status-list-box">
        <!-- style="flex: 0 0 8%" -->
        <div
          class="status-item"
          v-for="(v, k) in status_list"
          :key="`s` + k"
          :class="{ active: current_status === v.value }"
          @click="change_status(v.value)"
        >
          {{ v.name }} ({{ v.count }})
        </div>
        <div :class="['status-item',{active:current_status === 'collect'}]" @click="change_status('collect')">我的收藏({{ collect_count }})</div>
      </div>
      <div class="filter-box">
        <div class="filter-item">
          <Poptip trigger="hover" placement="bottom">
            <template #content>
              <div class="cate-box">
                <div v-for="(item,index) in cate_list" :class="['item',{active:item.product_category_id === form_data.product_category_id}]" :key="index" @click="onCateClick(item)">{{ item.category_name_cn }}</div>
              </div>
            </template>
            {{ curr_cate_name || '品类筛选' }}<Icon type="ios-arrow-down" />
          </Poptip>
        </div>
        <div class="filter-item">
          <Poptip trigger="hover" placement="bottom">
            <template #content>
              <div class="cate-box">
                <div v-for="(item,index) in orderby_list" :class="['item',{active:item.value === form_data.order_type}]" :key="index" @click="onOrderClick(item)">{{ item.name }}</div>
              </div>
            </template>
            {{ curr_order || '列表排序' }}<Icon type="ios-arrow-down" />
          </Poptip>
        </div>
        <div class="search">
          <img
            src="../../assets/images/icon-search.png"
            alt=""
            class="icon-search"
          />
          <input
            type="text"
            placeholder="搜索方案名称"
            v-model="form_data.keyword"
            class="input"
            @keyup.enter="search"
          />
        </div>
        <div style="width: 25px; height: 25px">
          <img
            v-if="list_mode == 'list'"
            src="../../assets/images/icon-list-mode-1.png"
            @click="list_mode = 'img'"
            style="width: 25px; height: 25px"
          />
          <img
            v-if="list_mode == 'img'"
            src="../../assets/images/icon-list-mode-2.png"
            @click="list_mode = 'list'"
            style="width: 25px; height: 25px"
          />
        </div>
      </div>
    </div>

    <template v-if="design_list.length > 0">
      <template v-if="list_mode === 'img'">
        <div class="img-mode-list">
          <div
            class="item"
            v-for="(item, index) in design_list"
            :key="`img${index}`"
            @mouseenter="onMouseEnter(index)"
            @mouseleave="onMouseLeave"
            @click="go(item)"
          >
            <div v-if="hoverIndex === index" class="img-hover">
              <div class="img-hover-container">
                <div class="img-hover-tags">{{ item.status_name }}</div>
                <div class="img-hover-btns">
                  <Button class="img-hover-btn-store" v-if="item.status===4&&item.is_store===0" @click="store(item)">加入版型库</Button>
                  <Button
                    class="img-hover-btn-store"
                    @click.stop="del(item.uuid)"
                    >删除</Button
                  >
                  <Button class="img-hover-btn-store" @click="copy(item.uuid)"
                    >复制创建新款</Button
                  >
                  <Button
                    class="img-hover-btn-store"
                    @click="onsale(item)"
                    v-if="item.status === 4"
                    >上架</Button
                  >
                  <Button
                    class="img-hover-btn-store"
                    v-if="item.status === 4"
                    @click.stop="checkout(item.uuid,true)"
                    >大货下单</Button
                  >
                </div>
              </div>
            </div>
            <img :src="item.image | default_img" class="img-mode-pic" />
            <div class="img-text-container">
              <div class="title">{{ item.name }}</div>
              <div class="date-time">{{ item.update_time }}</div>
            </div>
            <div class="style-no">款号：{{ item.style_no }}</div>
          </div>
        </div>
      </template>
      <template v-if="list_mode === 'list'">
        <div class="list">
          <div
            class="item"
            v-for="(v, k) in design_list"
            :key="`d` + k"
            @click="go(v)"
          >
            <div class="left">
              <img :src="v.image | default_img" alt="" class="image" />
            </div>
            <div class="right">
              <div class="right-box">
                <div class="name-wrap">
                  <div class="name">{{ v.name }}</div>
                  <div class="status" :class="oc(v)">{{ v.status_name }}</div>
                </div>
                <div class="style_no"><span>款号</span>：{{ v.style_no }}</div>
                <div class="category">
                  <span>款式分类</span>：{{ v.product_category_name }}
                </div>
                <div class="step" v-if="v.status >= 3">
                  设计报价：{{ v.factory_price }}元
                </div>
                <div class="desc">
                  <span>款式说明</span>：{{ v.description }}
                </div>
                <div class="time">创建时间：{{ v.create_time }}</div>
                <div class="btn-group">
                  <div v-if="!v.is_collected" class="btn btn-del" title="收藏" @click.stop="onCollectTemp(v.id)">收藏</div>
                  <div v-if="current_status == 'collect' || v.is_collected" class="btn btn-del" title="取消收藏" @click.stop="onCollectTemp(v.id)">取消收藏</div>
                  <!-- <div class="btn btn-design" v-if="v.status===4&&v.is_store===0" @click.stop="store(v)" title="加入版型库">加入版型库</div> -->
                  <div class="btn btn-del" @click.stop="del(v.uuid)" title="删除">删除</div>
                  <div class="btn btn-design" @click.stop="copy(v.uuid)" title="复制创建新款">
                    复制创建新款
                  </div>
                  <div
                    class="btn btn-del"
                    v-if="v.status === 4"
                    @click.stop="onsale(v)" title="上架"
                  >
                    上架
                  </div>
                  <div
                    class="btn btn-design"
                    v-if="v.status === 4"
                    @click.stop="checkout(v.uuid,true)" title="大货下单"
                  >
                    大货下单
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="load-more-tip" v-if="!load_end">
          <span v-if="loading">加载中...</span>
        </div>
        <div class="load-more-tip" v-else>
          <span>没有更多数据了</span>
        </div>
    </template>
    <template v-else>
      <img
        src="../../assets/images/no-data.png"
        style="width: 300px;height:300px; display: block; margin: 0 auto"
        alt=""
      />
    </template>
    <!-- 团队文件夹弹窗 -->
    <move-file
      ref="moveFilePop"
      v-if="show_move_file"
      :file="curr_file"
      :teamId="ownTeam.uuid"
      :teamName="ownTeam.name"
      :rootFolderType="1"
      @on-move-success="onGetTeamFolderFileList"
      @on-close="show_move_file = false"
    />
  </div>
</template>

<script>
import {
  collectTemp,
  CopyDesignToDraft,
  DeleteDesign,
  DesignCount,
  DesignList,
  getDesignCateList,
  Profile,
  StoreDesign,
  teamFileListForDesgin,
  teamFolderFileList,
  teamList
} from "@/api/index.js";
import { mapState } from 'vuex';
import MoveFile from "./DesignV3/components/MoveFile.vue";
export default {
  name: "WorkbenchMyTemplate",
  components: {
    MoveFile,
  },
  data() {
    return {
      form_data: {
        keyword: "",
        status: -1,
        page:1,
        limit:10,
        product_category_id:'',
        order_field:'',
        order_type:''
      },
      current_status: -1,
      status_list: {
        all: { name: "全部", value: -1, count: 0 },
        factory_bargain: { name: "待确认", value: 3, count: 0 },
        confirm_design: { name: "已确认", value: 4, count: 0 },
        // confirm_store: { name: "已加入", value: 5, count: 0 },
      },
      design_list: [],
      is_popup_show: false,
      current_design: {},
      list_mode: "list",
      hoverIndex: "",
      load_end: false,
      loading:false,
      team_list: [],
      curr_team: {},
      folder_list: [],
      show_move_file: false,
      curr_file: {},
      secondary_folder_list: [],
      curr_second_folder: {},
      team_file_list: [],
      show_more_folder: false,
      team_pattern_list: [],
      curr_cate_name:'',
      cate_list:[],
      orderby_list:[
        // {name:"最新款式(正序)",value:"latest",order:'asc'},
        {name:"最新款式",value:"latest",order:'desc'},
        {name:"使用次数(正序)",value:"used",order:'asc'},
        {name:"使用次数(倒序)",value:"used",order:'desc'}
      ],
      curr_order:'',
      collect_count:0,
    };
  },
  watch: {
    current_status(newVal, oldVal) {
      this.form_data.status = newVal;
      this.form_data.page = 1;
      this.getDesignList();
    },
    // list_mode(newVal, oldVal){
    // 	this.design_list = [];
    // 	this.onLoadMore();
    // }
  },
  computed: {
    ...mapState({
      userInfo:(state)=>state.userInfo
    }),
    avatar() {
      return this.profile.avatar || require("@/assets/images/avatar.png");
    },
    hasOwnTeam() {
      const { team_list } = this;
      return team_list.filter((item) => item.role === "所有者").length > 0;
    },
    folderList() {
      return this.folder_list.filter((item) => item.is_dir);
    },
    fileList() {
      return this.folder_list.filter((item) => !item.is_dir);
    },
    ownTeam() {
      const { team_list } = this;
      return team_list.find((item) => item.role === "所有者");
    },
    secondaryList() {
      if (this.show_more_folder) {
        return this.secondary_folder_list;
      } else {
        return this.secondary_folder_list.slice(0, 5);
      }
    },
  },
  async mounted() {
    await Promise.all([this.getProfile(), this.getDesignList(),this.onGetTeamList(),this.getCate()]);
    const { status } = this.$route.query;
    if (status) {
      this.current_status = status || -1;
    }
    this.$nextTick(() => {
      const container = this.$refs.scrollContainer;
      if (container) {
        container.addEventListener("scroll", this.handleScroll);
      }
      this.fixLayoutStyle();
    });
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听，防止内存泄漏
    const container = this.$refs.scrollContainer;
    if (container) {
      container.removeEventListener("scroll", this.handleScroll);
    }
    this.restoreLayoutStyle();
  },
  methods: {
    async onCollectTemp(id){
      try{
        const {code,msg} = await collectTemp({id});
        if(code>0){
          this.$layer.msg(msg);
          return;
        }
        this.$layer.msg('操作成功~');
        this.getDesignList();
      }catch(e){
        console.log('err-collect-temp',e);
      }
    },
    onOrderClick({name,value,order}){
      this.curr_order = name;
      this.form_data.order_type = order;
      this.form_data.order_field = value;
      this.design_list = [];
      this.getDesignList();
    },
    async getCate(){
      try{
        const {code,msg,data} = await getDesignCateList({});
        if(code>0){
          this.$layer.msg(msg);
          return;
        }
        this.cate_list = [{product_category_id:'',category_name_cn:'全部'},...data];
      }catch(e){
        console.log('err-cate-list',e);
      }
    },
    onCateClick({product_category_id,category_name_cn}){
      this.curr_cate_name = category_name_cn;
      this.form_data.product_category_id = product_category_id;
      this.design_list = [];
      this.getDesignList();
    },
    fixLayoutStyle(){
      const layoutEl = document.querySelector('.layout');
      const menuEl = document.querySelector('.layout .center .menu');
      const contentEl = document.querySelector('.layout .center .content');
      console.log('contentEl===>',contentEl);
      if(layoutEl){
        layoutEl.style.setProperty('max-height','calc(100vh - 150px)','important');
        layoutEl.style.setProperty('min-height','0','important');

        //>隐藏滚动条
        layoutEl.classList.add('hide-scrollbar');
      }
      if(menuEl){
        menuEl.style.setProperty('max-height','calc(100vh - 150px)','important');
        menuEl.style.setProperty('min-height','0','important');
      }
      if(contentEl){
        contentEl.style.setProperty('padding-bottom','0','important');
        contentEl.style.setProperty('margin-bottom','0','important');
      }
    },
    restoreLayoutStyle(){
      const layoutEl = document.querySelector('.layout');
      const menuEl = document.querySelector('.layout .center .menu');
      const contentEl = document.querySelector('.layout .center .content');
      if(layoutEl){
        layoutEl.style.removeProperty('max-height');
        layoutEl.style.setProperty('min-height','calc(100vh - 100px)','important');
        layoutEl.classList.remove('hide-scrollbar');
      }
      if(menuEl){
        menuEl.style.removeProperty('max-height');
        menuEl.style.setProperty('min-height','calc(100vh - 80px)','important');
      }
      if(contentEl){
        contentEl.style.setProperty('padding-bottom','80px','important');
        contentEl.style.setProperty('margin-bottom','50px','important');
      }
    },
    async onGetTeamFileForDesign(is_all = false) {
      try {
        const { curr_second_folder, curr_team, folderList, form_data_pattern } =
          this;
        const { page, size, keyword } = form_data_pattern;
        const param = {};
        param.page = page;
        param.size = size;
        param.keyword = keyword;
        param.team_uuid = curr_team.uuid;
        param.folder_uuid = is_all
          ? folderList[0].uuid
          : curr_second_folder.uuid || folderList[0].uuid;
        const { code, msg, data } = await teamFileListForDesgin(param);
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        console.log("data", data);
        this.team_pattern_list = data.list;
        this.total = data.count;
      } catch (e) {
        console.log("err-get-team-file-list-design", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      }
    },
    onAddTeamFile(file) {
      console.log('file--->add-team-file--->',file);
      this.curr_file = file;
      this.show_move_file = true;
    },
    async onTeamChoose(team) {
      if (!team) return;
      this.curr_team = team;
      await this.onGetTeamFolderFileList();
      await this.onGetTeamFolderFileList(this.folder_list[0], false, true);
      await this.onGetTeamFolderFileList(
        this.secondary_folder_list[0],
        true,
        true
      );
      await this.onGetFileCount();
      await this.onGetTeamFileForDesign();
    },
    async onGetTeamFolderFileList(
      folder = {},
      is_file = false,
      is_all = false
    ) {
      try {
        if (!this.curr_team) return;
        if (!is_all) {
          this.curr_second_folder = folder;
        } else {
          this.curr_second_folder = {};
        }
        if (is_file) {
          this.onGetTeamFileForDesign(false);
        }
        const param = {};
        param.team_uuid = this.curr_team.uuid;
        param.parent_directory_uuid = folder.uuid || "";
        const { code, msg, data } = await teamFolderFileList(param);
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        if (!folder || !folder.uuid) {
          this.folder_list = data.filter((item) => item.type == 1);
        } else {
          if (!is_file) {
            this.secondary_folder_list = data.filter((item) => item.is_dir);
          }
        }
      } catch (e) {
        console.log("err-get-file-folder-list", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      }
    },
    async onGetTeamList() {
      try {
        const { code, msg, data } = await teamList();
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        console.log("data-team-list", data);
        if (!data.length) {
          this.team_list = [];
          this.curr_team = {};
          return;
        }
        this.team_list = data;
        let curr_team = data.filter((item) => item.role === "所有者")[0];
        if (!curr_team) {
          curr_team = data[0];
        }
        this.curr_team = curr_team;
      } catch (e) {
        console.log("err-team-list", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      }
    },
    handleScroll(e) {
      const target = e.target;
      console.log('aaaa');
      // 滚动条距离底部的距离 < 50px 时触发加载
      const isBottom =
        target.scrollHeight - target.scrollTop - target.clientHeight < 50;

      if (isBottom && !this.loading && !this.load_end) {
        this.onLoadMore();
      }
    },
    onLoadMore() {
      if (this.loading || this.load_end) return;
      this.form_data.page++;
      this.getDesignList(true); 
    },
    onMouseEnter(index, e) {
      this.hoverIndex = index;
    },
    onMouseLeave(e) {
      this.hoverIndex = "";
    },
    copy(uuid) {
      this.$DModal.confirm({
        content: "确认复制该款式到草稿么？",
        onOK: () => {
          CopyDesignToDraft({ uuid }).then((response) => {
            this.$router.push({
              name: "WorkBenchDesign",
              query: { uuid: response.data.uuid, is_copy: 1 },
            });
          });
        },
      });
    },
    store(v) {
      this.$DModal.confirm({
        content: "确认该款式加入我的版型么？",
        onOK: () => {
          StoreDesign({ uuid:v.uuid }).then(() => {
            this.$layer.msg(`操作成功`);
          }).finally(() => {
            this.getDesignList();
          });
        },
      });
    },
    onsale({ uuid, product }) {
      if(!this.userInfo.shop_status || this.userInfo.shop_status != 1){
        this.$layer.msg('请先申请开店~');
        return;
      }
      if (product) {
        //>已上架过商品的款式直接跳转编辑商品
        this.$router.push({
          name: "ProductEdit",
          query: { uuid: product.uuid },
        });
        return;
      }
      this.$router.push({ name: "ProductEdit", query: { design_uuid: uuid } });
    },
    search() {
      this.form_data.page = 1;
      this.load_end = false;
      this.design_list = [];
      this.getDesignList();
    },
    oc(v) {
      return [v.status_text];
    },
    change_status(s) {
      this.current_status = s;
    },
    go(v) {
      this.checkout(v.uuid);
    },
    del(uuid) {
      this.$DModal.confirm({
        content: "确认删除该设计么？",
        onOK: () => {
          DeleteDesign({ uuid })
            .then(() => {
              this.$layer.msg(`操作成功`);
            })
            .finally(() => {
              this.getDesignList();
            });
        },
      });
    },
    checkout(uuid,is_big_order=false) {
      const query = { uuid, from: "design", is_big_order };
      this.$router.push({
        name: "WorkBenchSummary",
        query: query,
      });
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    async getDesignList(isLoadMore = false) {
      if (this.loading) return;
      this.loading = true;
      try {
        if(this.current_status === 'collect'){
          this.form_data.collect_list = true;
          this.form_data.status = -1;
        }else{
          this.form_data.collect_list = null;
        }
        const { code, msg, data } = await DesignList(this.form_data);
        const {code:code_dc,msg:msg_dc,data:data_dc} = await DesignCount(this.form_data);
        if(code_dc>0){
          this.$layer.msg(msg_dc);
        }
        for (let code in data_dc) {
            if(code != 'collect_count'){
              if(this.status_list[code]){ // 先检查是否存在该键
                this.status_list[code].count = data_dc[code];
              }
            }
        }
        if(data_dc['collect_count']){
          this.collect_count = data_dc['collect_count'] || 0;
        }
        if (code > 0) {
          this.$layer.msg(msg);
        }
        if (isLoadMore) {
          this.design_list = [...this.design_list, ...data];
        } else {
          this.design_list = data;
        }
        if (data.length < this.form_data.limit) {
          this.load_end = true;
        } else {
          this.load_end = false;
        }
      } catch (error) {
        console.error("获取设计列表失败", error);
        this.$layer.msg("加载失败，请重试");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .router{
  max-height:calc(100vh - 130px) !important;
  // overflow-y:auto !important;
}
.container {
  padding: 0 70px 0 30px;
  background: white;
  height:calc(100vh - 130px);
  overflow-y:auto;
  &::-webkit-scrollbar{
    display:none !important;
  }
  .load-more-tip {
    width: 100%;
    text-align: center;
    padding: 20px 0;
    color: #999;
    font-size: 14px;
  }
  .status-list {
    // position: relative;
    padding: 30px 0;
    display: flex;
    align-content: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .status-list-box{
      flex:1;
      display:flex;
      column-gap:14px;
    }
    .status-item {
      // margin: 0 14px;
      // width: 80px;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      text-align: center;
      flex-shrink:0;
      cursor: pointer;
      padding:0 10px;
      &.active {
        background: #fa3d5a;
        border-radius: 5px;
        color: white;
      }
      &:first-child {
        margin-left: 0;
      }
    }
    .filter-box{
      display:flex;
      align-items:center;
      column-gap:10px;
      .filter-item{
        display:flex;
        align-items:center;
        justify-content:center;
        column-gap:5px;
        border:1px solid #f0f0f0;
        border-radius:30px;
        padding:5px 10px;
        font-size:14px;
        cursor:pointer;
        .cate-box{
          width:100%;
          max-height:300px;
          overflow-y:auto;
          &::-webkit-scrollbar{
            display:none;
          }
        }
        .item{
          width:100%;
          height:30px;
          display:flex;
          align-items:center;
          justify-content:center;
          cursor:pointer;
          &.active, &:hover{
            background:rgba(0,0,0,0.03);
          }
        }
      }
    }
    .search {
      // position: absolute;
      // top: 23px;
      // right: 0;
      position:relative;
      .icon-search {
        position: absolute;
        top: 15px;
        left: 20px;
        width: 20px;
        height: 20px;
      }
      .input {
        width: 260px;
        height: 50px;
        line-height: 50px;
        border-radius: 25px;
        padding-left: 50px;
        background: #f3f4f6;
        font-size: 14px;
        outline: none;
        border: none;
      }
    }
  }
  .img-mode-list {
    display: flex;
    align-items: flex-start;
    width: 100%;
    overflow-x: auto;
    flex-wrap: wrap;
    column-count: 4;
    column-gap: 20px;
    .item {
      position: relative;
      // display:block;
      // flex: 0 0 230px;
      width: 290px;
      border-radius: 10px;
      // margin-right: 20px;
      margin-bottom: 30px;

      .img-hover {
        position: absolute;
        width: 100%;
        border-radius: 10px;
        height: 290px;
        background: rgba(0, 0, 0, 0.25);
        padding:5px;

        .img-hover-container {
          position: relative;
          width: 100%;
          height: 100%;

          .img-hover-tags {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: white;
            margin-top: 15px;
            margin-left: 15px;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
            background: #fc8c16;
            width: 60px;
          }

          .img-hover-btns {
            display: flex;
            flex-wrap:wrap;
            row-gap:10px;
            justify-content: flex-end;
            align-items: center;
            position: absolute;
            bottom: 30px;
            right: 0px;

            .img-hover-btn-store {
              border: none;
              margin-right: 5px;
              color: black;
              height: 35px;

              &:nth-last-child(1) {
                background: #fa3d5a;
                color: #ffffff;
              }
            }

            .img-hover-btn-price {
              background: #fa3d5a;
              color: white;
              border: none;
              margin-right: 5px;
              height: 35px;
            }
          }
        }
      }
    }

    .img-mode-pic {
      width: 100%;
      height: 290px;
      border-radius: 10px;
      border: 1px solid #ebedf2;
      object-fit: cover;
    }

    .img-text-container {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        font-weight: bold;
        font-size: 16px;
        flex: 0 0 55%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #000000;
      }

      .date-time {
        color: #888888;
        font-size: 12px;
        flex: 0 0 45%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: right;
      }
    }

    .style-no {
      color: #4d4d4d;
      font-size: 14px;
    }
  }
  .list {
    padding: 10px 0 50px 0;
    display: flex;
    align-items: center;
    // column-gap:20px;
    // row-gap:20px;
    flex-wrap: wrap;
    box-sizing: border-box;
    gap: 20px;
    .item {
      display: flex;
      flex-wrap: nowrap;
      // width: 750px;
      // flex:0 1 48%;
      flex: 0 0 calc(50% - 10px);
      max-width: 48%;
      height: 270px;
      // margin:0 20px 20px 0;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #ebedf2;
      cursor: pointer;
      .left {
        width: 240px;
        // height: 240px;
        height: 100%;
        flex-shrink: 0;
        .image {
          border: 1px solid #ebedf2;
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 10px 0 0 10px;
        }
      }
      .right {
        // padding: 0 20px;
        // width: 480px;
        flex: 1;
        max-width: calc(100% - 240px);
        .right-box {
          padding: 0 20px;

          .name-wrap {
            height: 53px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #ebedf2;
            .name {
              font-size: 18px;
              color: #333333;
              font-weight: bold;
              white-space:nowrap;
              text-overflow:ellipsis;
              overflow:hidden;
            }
            .status {
              width: 70px;
              height: 25px;
              line-height: 25px;
              border-radius: 5px 0px 5px 0px;
              text-align: center;
              font-family: "Microsoft YaHei";
              white-space:nowrap;
              text-overflow:ellipsis;
              overflow:hidden;
              &.draft {
                color: #30c6d0;
                border: 1px solid #30c6d0;
              }
              &.bargain {
                color: #ff9000;
                border: 1px solid #ff9000;
              }
              &.confirm_design {
                color: #e72c28;
                border: 1px solid #e72c28;
              }
            }
          }

          .style_no,
          .category,
          .desc {
            margin: 6px 0;
            color: #707070;
            font-size: 14px;
            white-space:nowrap;
              text-overflow:ellipsis;
              overflow:hidden;
          }
          .desc {
            height: 40px;
            overflow-y: hidden;
          }

          span {
            color: #4d4d4d;
            font-size: 14px;
          }

          .time {
            margin: 5px 0;
            font-size: 12px;
            color: #808080;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          .btn-group {
            margin-top: 23px;
            display: flex;
            justify-content: flex-end;
            .btn {
              // width: 100px;
              padding: 0 10px;
              height: 35px;
              line-height: 35px;
              text-align: center;
              border-radius: 5px;
              font-size: 14px;
              margin: 0 5px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              &.btn-del {
                border: 1px solid #d0d2d6;
                color: #68696a;
              }
              &.btn-design {
                background: #fa3d5a;
                color: white;
              }
            }
          }
        }
      }

      &:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
}

::v-deep .popup-modal {
  h2 {
    padding: 10px 20px;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid #f0f0f0;
  }

  .table {
    margin: 10px 0;
    display: flex;
    flex-wrap: nowrap;
    .item {
      flex: 1;
      .th {
        background: #f2f2f2;
      }
      .td {
        height: 55px;
        line-height: 55px;
        text-align: center;
        color: #191a1c;
        border: 1px solid #e3e3e3;
      }
    }
  }

  .btn-submit {
    margin: 40px auto;
    width: 110px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #fa3d5a;
    color: white;
    border-radius: 6px;
    cursor: pointer;
  }
}

@media (min-width: 1280px) and (max-width: 1679px) {
  .container .img-mode-list {
    column-count: 4;
    column-gap: 10px;
    .item {
      width: 261px;
      border-radius: 10px;
      margin-bottom: 30px;

      .img-hover {
        height: 261px;
      }
    }

    .img-mode-pic {
      height: 261px;
    }
  }
}

@media (max-width: 1279px) {
  .container .img-mode-list {
    column-count: 4;
    column-gap: 10px;
    .item {
      width: 222px;
      border-radius: 10px;
      margin-bottom: 30px;

      .img-hover {
        height: 222px;
      }
    }

    .img-mode-pic {
      height: 222px;
    }
  }
}
</style>
